/** @format */

$(function() {
    /* query ready function */

    /* /Dashboard/Index */
    if ($(".myaccount-page").length > 0) {



  

    } // if

});
